// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// supported languages
const supportedLanguages = ['en', 'es', 'fr'];

i18n
	.use(HttpBackend) // Load translations using http backend (e.g. from public/local)
	.use(LanguageDetector) // Detects the user's language
	.use(initReactI18next) // Pass i18n down a react-i18next
	.init({
		fallbackLng: 'en', // Backup language if the detected language is not available
		supportedLanguages, //
		debug: process.env.NODE_ENV === 'development', // Console logs in development
		interpolation: {
			escapeValue: false,
		},
		backend: {
			loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
		},
		detection: {
			order: ['localStorage', 'navigator'], // Priority: localStorage, then browser
			caches: ['localStorage'], // Store in localStorage
			lookupLocalStorage: 'i18nextLng', // LocalStorage key
		},
		// react-i18next options
		react: {
			useSuspense: true, // Use Suspense for translation loading (recommended)
		},
	});

// Check language on initialization
i18n.on('initialized', () => {
	const currentLng = i18n.language;
	if (!supportedLanguages.includes(currentLng)) {
		i18n.changeLanguage('en'); // Change to “en” if not supported
	}
});

// Check language when changing it
i18n.on('languageChanged', (lng) => {
	if (!supportedLanguages.includes(lng)) {
		i18n.changeLanguage('en');
	}
});

export default i18n;
